// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { cartLinesListHeaderStyles } from "@sc/Overrides/Components/CartLinesListHeader";
import EditCart from "@sc/XDL/Icons/EditCart";
import { createLinkIconStyles } from "@sc/XDL/Utilities";
import { css } from "styled-components";

cartLinesListHeaderStyles.wrapper = {
    css: css`
        display: flex;
        justify-content: space-between;
    `,
};

cartLinesListHeaderStyles.productCountText = {
    variant: "h3",
    forwardAs: "p",
    css: css`
        margin-bottom: 0;
    `,
};
cartLinesListHeaderStyles.titleWrapper = {
    css: css`
        display: flex;
        column-gap: 24px;
        margin-bottom: 16px;
        align-items: flex-start;
    `,
};

cartLinesListHeaderStyles.editCartLink = {
    ...createLinkIconStyles(EditCart, {
        icon: {
            iconProps: {
                size: 13,
                css: css`
                    &,
                    svg {
                        width: 12px;
                    }
                `,
            },
        },
        css: css`
            margin-top: 11px;
        `,
    }),
};
